<main class="p-5 grey lighten-5">
  <div class="container">
    <div class="card my-3 card-image">
      <!-- <img class="card-img-top" src="http://static.szallasoutlet.hu/uploaded_images/accomodation/267001698/264826100/orig/01.jpg"> -->
      <div class="card-body text-center pb-0">
        <h2 class="card-title" translate>FORM.TITLE_WELCOME</h2>
        <p>{{'FORM.ADDRESSING'|translate:(gs.name$|async)}}</p>
        <p [innerHTML]="'FORM.PRELUDE'|translate"></p>
      </div>
    </div>


    <div class="row my-4">
      <div class="col">
        <h2 translate>FORM.LOCATION.TITLE</h2>
        <div class="card-deck">

          <div class="card">
            <div class="card-body">
              <p translate>FORM.LOCATION.PRELUDE</p>

              <div class="alert alert-warning">
                <span [innerHTML]="'FORM.LOCATION.WARNING'|translate"></span>
                <a pageScroll href="#accomodation" class="float-right pt-2">
                  <i class='fa fa-info-circle'></i>
                  <span translate>FORM.LOCATION.SEE_DETAILS</span>
                </a>
              </div>

            </div>
            <div class="card-actions text-center">
              <h4 class="card-title" translate>FORM.LOCATION.ADDRESS_1</h4>
              <h6 class="card-subtitle text-muted" translate>FORM.LOCATION.ADDRESS_2</h6>
              <p translate>FORM.LOCATION.ADDRESS_3</p>
              <p translate>FORM.LOCATION.ADDRESS_4</p>
            </div>
          </div>
          <div class="card card-map">
            <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d293345.0818684938!2d18.966316112059904!3d46.91499983613997!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xe74edc6ac92e67aa!2zU3pha8OhdHMga2FzdMOpbHksIFN6ZW50IEFuZHLDoXMga2FzdMOpbHkgw6lzIHZlbmTDqWdow6F6IChQaW5jw6lzemV0KQ!5e0!3m2!1shu!2shu!4v1528319001744"
              frameborder="0" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="alert text-center">
          <i class="fa fa-bell red-text px-2"></i>
          <span translate>FORM.REMINDER</span>
          <a pageScroll href="#rsvp" class="btn btn-sm btn-rounded btn-info fs-3 px-4" translate>FORM.FEEDBACK</a>
        </div>
      </div>
    </div>
    <div class="row my-4">
      <div class="col">
        <h2 translate>FORM.PROGRAM.TITLE</h2>

        <ul class="stepper stepper-vertical timeline-simple pl-0">

          <li>
            <a>
              <span class="circle grey">
                <i class="fa fa-plane"></i>
              </span>
            </a>
            <div class="step-content z-depth-1 ml-xl-0">
              <h5 translate="">FORM.PROGRAM.1.TITLE</h5>
              <p class="text-muted mt-3">
                <i class="far fa-clock" aria-hidden="true"></i>
                <span translate>FORM.PROGRAM.1.TIME</span>
              </p>
              <p translate>FORM.PROGRAM.1.CONTENT</p>
            </div>
          </li>
          <li>
            <a>
              <span class="circle grey">
                <i class="fa fa-utensils"></i>
              </span>
            </a>
            <div class="step-content z-depth-1 ml-xl-0">
              <h5 translate="">FORM.PROGRAM.2.TITLE</h5>
              <p class="text-muted mt-3">
                <i class="far fa-clock" aria-hidden="true"></i>
                <span translate>FORM.PROGRAM.2.TIME</span>
              </p>
              <p translate>FORM.PROGRAM.2.CONTENT</p>
            </div>
          </li>
          <li>
            <a>
              <span class="circle grey">
                <i class="fa fa-car"></i>
              </span>
            </a>
            <div class="step-content z-depth-1 ml-xl-0">
              <h5 translate="">FORM.PROGRAM.3.TITLE</h5>
              <p class="text-muted mt-3">
                <i class="far fa-clock" aria-hidden="true"></i>
                <span translate>FORM.PROGRAM.3.TIME</span>
              </p>
              <p translate>FORM.PROGRAM.3.CONTENT</p>
            </div>
          </li>
          <li>
            <a>
              <span class="circle grey">
                <i class="fa fa-glass-martini"></i>
              </span>
            </a>
            <div class="step-content z-depth-1 ml-xl-0">
              <h5 translate="">FORM.PROGRAM.4.TITLE</h5>
              <p class="text-muted mt-3">
                <i class="far fa-clock" aria-hidden="true"></i>
                <span translate>FORM.PROGRAM.4.TIME</span>
              </p>
              <p translate>FORM.PROGRAM.4.CONTENT</p>
            </div>
          </li>
          <li>
            <a>
              <span class="circle darkgoldenrod">
                <i class="fa fa-infinity"></i>
              </span>
            </a>
            <div class="step-content z-depth-1 ml-xl-0">
              <h3 translate>FORM.PROGRAM.5.TITLE</h3>
              <h5 class="mt-3">
                <i class="far fa-clock" aria-hidden="true"></i>
                <span translate>FORM.PROGRAM.5.TIME</span>
              </h5>
              <p translate>FORM.PROGRAM.5.CONTENT</p>
              <div class="alert alert-warning" translate>FORM.PROGRAM.5.WARNING</div>
            </div>
          </li>
          <li>
            <a>
              <span class="circle grey">
                <i class="fa fa-camera"></i>
              </span>
            </a>
            <div class="step-content z-depth-1 ml-xl-0">
              <h5 translate="">FORM.PROGRAM.6.TITLE</h5>
              <p translate>FORM.PROGRAM.6.CONTENT</p>
            </div>
          </li>
          <li>
            <a>
              <span class="circle grey">
                <i class="fa fa-utensils"></i>
              </span>
            </a>
            <div class="step-content z-depth-1 ml-xl-0">
              <h5 translate="">FORM.PROGRAM.7.TITLE</h5>
              <p class="text-muted mt-3">
                <i class="far fa-clock" aria-hidden="true"></i>
                <span translate>FORM.PROGRAM.7.TIME</span>
              </p>
              <p translate>FORM.PROGRAM.7.CONTENT</p>
            </div>
          </li>
          <li>
            <a>
              <span class="circle grey">
                <i class="fa fa-coffee"></i>
              </span>
            </a>
            <div class="step-content z-depth-1 ml-xl-0">
              <h5 translate="">FORM.PROGRAM.8.TITLE</h5>
              <p class="text-muted mt-3">
                <i class="far fa-clock" aria-hidden="true"></i>
                <span translate>FORM.PROGRAM.8.TIME</span>
              </p>
              <p translate>FORM.PROGRAM.8.CONTENT</p>
              <p>(
                <span translate>FORM.PROGRAM.8.REQUEST</span>
                <a pageScroll href="#rsvp" translate>FORM.PROGRAM.8.RSVP</a>
                <i class="fa fa-arrow-down"></i>
                )</p>
            </div>
          </li>
        </ul>
      </div>
    </div>


    <div class="row my-4">
      <div class="col">
        <h2 id="accomodation" translate>FORM.ACCOMODATION.TITLE</h2>
        <div class="card">
          <div class="card-body">
            <span [innerHTML]="'FORM.ACCOMODATION.CONTENT'|translate"></span>
            <div class="alert alert-warning" [innerHTML]="'FORM.ACCOMODATION.WARNING'|translate"></div>
            <div class="alert alert-warning" [innerHTML]="'FORM.ACCOMODATION.NOTE2'|translate"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="row my-4">
      <div class="col">
        <h2 id="meals" translate>FORM.MEALS.TITLE</h2>
        <div class="card">
          <div class="card-body">
            <p [innerHTML]="'FORM.MEALS.CONTENT'|translate"></p>
            <ul>
              <li>
                Dunaföldvár Vár Étterem -
                <a href="http://www.varetterem.hu/" target="_blank">http://www.varetterem.hu/</a>
              </li>
              <li>
                Centrum Restaurant and Salatbar -
                <a href="http://www.centrumetterem.hu/" target="_blank">http://www.centrumetterem.hu/</a>
              </li>
              <li>
                Rakpart Étterem -
                <a href="http://rakpart-etterem.business.site/" target="_blank">http://rakpart-etterem.business.site/</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="row my-5">
      <div class="col">

        <h2 id="rsvp" translate>FORM.RSVP.TITLE</h2>
        <div class="card">
          <div class="card-body">
            <a class="float-right badge text-white" [ngClass]="{'badge-danger':saveState==='ERROR','badge-warning':saveState==='DIRTY','badge-success':saveState==='SAVED'}"
              (click)="forceSave()">
              <i class="fa fa-fw" [ngClass]="{'fa-exclamation-triangle':saveState==='ERROR','fa-pencil-alt':saveState==='DIRTY','fa-save':saveState==='SAVED'}"></i>
              {{("FORM.RSVP.STATUS."+saveState) | translate}}
            </a>
            <h3 class="card-title" translate>FORM.RSVP.PRELUDE</h3>
            <form [formGroup]="guestForm" novalidate>
              <table class="table mb-0">
                <thead class="blue-grey lighten-5">
                  <tr>
                    <th>
                      <h3 translate>FORM.RSVP.ACCOMODATION</h3>
                    </th>
                    <th [innerHTML]="'FORM.DATE_0'|translate"></th>
                    <th [innerHTML]="'FORM.DATE_1'|translate"></th>
                    <th [innerHTML]="'FORM.DATE_2'|translate"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <p translate>FORM.RSVP.WHICH_DAY</p>
                      <p translate>FORM.RSVP.WANT_BREAKFAST</p>
                    </td>
                    <td>
                      <div class="switch round success-switch">
                        <label>
                          <input type="checkbox" formControlName="day_1">
                          <span class="lever"></span>
                        </label>
                      </div>
                    </td>
                    <td>
                      <div class="switch round success-switch">
                        <label>
                          <input type="checkbox" formControlName="day_2">
                          <span class="lever"></span>
                        </label>
                      </div>
                    </td>
                    <td>
                      <p>
                        <i class="fa fa-utensils"></i>
                        <span translate>FORM.RSVP.BREAKFAST</span>
                      </p>
                      <div class="switch round success-switch">
                        <label>
                          <input type="checkbox" formControlName="breakfast">
                          <span class="lever"></span>
                        </label>
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="day1 || day2">
                    <td translate>FORM.RSVP.HEADCOUNT.ADULTS</td>
                    <td>
                      <bar-rating *ngIf="day1" class="br-adult" [max]="5" [theme]="'fontawesome'" formControlName="adults_day1"></bar-rating>
                    </td>
                    <td>
                      <bar-rating *ngIf="day2" class="br-adult" [max]="5" [theme]="'fontawesome'" formControlName="adults_day2"></bar-rating>
                    </td>
                    <td></td>
                  </tr>
                  <tr *ngIf="day1 || day2">
                    <td translate>FORM.RSVP.HEADCOUNT.KIDS</td>
                    <td>
                      <bar-rating *ngIf="day1" class="br-child" [max]="5" [theme]="'fontawesome'" formControlName="kids_day1"></bar-rating>
                    </td>
                    <td>
                      <bar-rating *ngIf="day2" class="br-child" [max]="5" [theme]="'fontawesome'" formControlName="kids_day2"></bar-rating>
                    </td>
                    <td></td>
                  </tr>
                  <tr *ngIf="day1 || day2">
                    <td translate>FORM.RSVP.HEADCOUNT.CHILDREN</td>
                    <td>
                      <bar-rating *ngIf="day1" class="br-baby" [max]="5" [theme]="'fontawesome'" formControlName="babies_day1"></bar-rating>
                    </td>
                    <td>
                      <bar-rating *ngIf="day2" class="br-baby" [max]="5" [theme]="'fontawesome'" formControlName="babies_day2"></bar-rating>
                    </td>
                    <td></td>
                  </tr>
                  <tr class="blue-grey lighten-5">
                    <td colspan="4">
                      <h3 translate>FORM.RSVP.COMMENTS.TITLE</h3>
                    </td>
                  </tr>
                  <tr>
                    <td translate>FORM.RSVP.COMMENTS.LABEL</td>
                    <td colspan="3">
                      <div class="form-group shadow-textarea mb-0">
                        <textarea formControlName="comments" class="form-control z-depth-1 mb-0" id="comments-text" rows="10" [placeholder]="'FORM.RSVP.COMMENTS.PLACEHOLDER'|translate"></textarea>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="text-center">
                <button type="submit" class="btn btn-rounded btn-info" (click)="forceSave()">
                  <i class="fa fa-floppy-o fa-3x" aria-hidden="true"></i>
                  <span translate>FORM.RSVP.SAVE_BUTTON</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>


// WEBPACK FOOTER //
// ./src/app/components/form/form.component.html